import { Divider } from '@mui/material';
import React from 'react';
export const TreeItemDivider = ({ sx }) => {
    return React.createElement(Divider, { flexItem: true, orientation: 'vertical', sx: [{ mt: 1, mb: 1 }, ...(Array.isArray(sx) ? sx : [sx])] });
};
